import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const SubCategories = (props) => {
  const MAX_DEFAULT_CATEGORIES_SHOWN = 5;

  const activeSubCategory = window.location.pathname.slice(1).split('/')[2];

  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const {breadcrumbs, categoryPath, hasChildren, parentId} = useSelector(
    (state) => state.galleryData
  );

  const [seeMore, setSeeMore] = useState(false);

  const mountCategoryHref = (currentCategoryPath) => {
    // get the current path from the last level of the breadcrumb
    const pathname = breadcrumbs?.slice(-1)[0]?.href;
    // just add the current category path if it's not in the higher hierarchy level (no parents)
    // to avoid duplicates, and if it's not int the lower level (no children)
    const parentCategoryPath = hasChildren && parentId ? `${categoryPath}/` : '';
    return `${pathname}/${parentCategoryPath}${currentCategoryPath}/?filter=${
      window.cards_page ? 'card' : 'invitation'
    }`;
  };

  return props.group.length > 0
    ? <ul className="subcategory__list">
        {props.group.map((category, index) => {
          if (!largeScreens || seeMore || index < MAX_DEFAULT_CATEGORIES_SHOWN) {
            return (
              <li
                className="subcategory__item"
                key={category.categoryId}
                data-qa-id="gallery_subcategoryWrapper"
              >
                <a
                  className={`subcategory__label ${
                    activeSubCategory === category.categoryId ? 'active' : ''
                  }`}
                  data-qa-id={`gallery_subcategory__${category.categoryId}--${category.categoryId}_link`}
                  href={mountCategoryHref(category.categoryPath)}
                >
                  {category.displayName}
                </a>
              </li>
            );
          }
        })}
        {largeScreens && props.group.length > MAX_DEFAULT_CATEGORIES_SHOWN && !seeMore && (
          // biome-ignore lint/a11y/useButtonType: existing error
          <button
            onClick={() => setSeeMore(true)}
            className="unstyled-button paragraph3 subcategory__label subcategory__see-more-btn"
            data-qa-id="gallery_subCategory_ShowMoreButton"
          >
            See more
          </button>
        )}
      </ul>
    : // biome-ignore lint/complexity/noUselessFragments: existing error
      <></>;
};

SubCategories.propTypes = {
  group: PropTypes.arrayOf(PropTypes.object).isRequired,
};
